import { useMemo} from "react"


export const GridLine = ({ element, hoverIndex, processAllData, cursorColor}: any) => {
 
 const processedItems = useMemo(() => {
  return element
 }, [element])




 return (
  <div  className="flex items-stretch">
   {processedItems.map((subElement: any, subIndx: number) => (
    <div
     key={subIndx}
     className={`flex items-stretch py-[0.5px] w-6 h-4 ${
      hoverIndex === subIndx ? "w-6 border-blue-200 opacity-60" : ""
     }`}
     style={{
      background: hoverIndex === subIndx ? cursorColor : undefined,
      borderLeftWidth: hoverIndex === subIndx ? "2px" : "",
      borderRightWidth: hoverIndex === subIndx ? "3px" : "",
     }}
    >
     {processAllData(subElement, subIndx, element)}
    </div>
   ))}
  </div>
 )
}
